import * as Sentry from '@sentry/browser';
import { useEffect } from 'react';
import noop from 'lib/noop';

export const useScript = (src, callback = noop) => {
  useEffect(() => {
    const script = document.createElement('script');

    script.src = src;
    script.onload = callback;
    script.onerror = () => {
      Sentry.captureMessage(`script: ${src} has failed to load`);
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [src, callback]);
};
